import { breakpoints, IconRegularClose, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const BottomContainer = styled.div`
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: white;
  z-index: 10;
  display: flex;
  justify-content: center;
  box-shadow: 0px -2px 4px 0px #47474714, 0px -1px 2px 0px #4747470a;
`;

export const Container = styled.div`
  padding: 1.25rem 1rem;
  position: relative;
  flex-basis: 500px;
`;

export const ButtonsWrapper = styled.div<{ disabled: boolean }>`
  display: flex;
  gap: 0.5rem;
  flex-direction: column;

  > * {
    width: 100%;
  }

  svg {
    color: ${({ disabled }) =>
      disabled ? theme.color.icon.disabled : theme.color.icon.primary};
  }

  @media (min-width: ${breakpoints.md}) {
    padding-bottom: 0;
    flex-direction: row-reverse;
    > * {
      width: 250px;
    }
  }
`;

export const CloseButtonWrapper = styled.span`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 100rem;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${theme.color.border.selected};
    outline-offset: 2px;
    background-color: ${theme.color.background.primaryHover};
  }
`;

export const CloseButton = styled(IconRegularClose)`
  color: ${theme.color.icon.secondary};

  width: 20px;
  height: 20px;
`;
